import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ACCEPT_VERSION_HEADER,
  AuthHttpService,
} from '../auth-data/auth-http.service';
import { IResponseInfo } from '../http/http.data';
import { GlobalSearch } from './global-search.model';
import { DocumentsSearch } from './document-search.model';
import { ISearchParams } from './search-data.data';
import { RecentDocumentsSearch } from './recent-documents-search.model';
import { map } from 'rxjs/operators';

export const GLOBAL_SEARCH_URL = '/search';
export const DOCUMENTS_SEARCH_URL = '/search/documents';
export const RECENT_DOCUMENTS_SEARCH_URL = '/recent_documents';
export const GLOBAL_SEARCH_ACCEPT_VERSION = '2.0.0';
export const DOCUMENTS_SEARCH_ACCEPT_VERSION = '1.0.0';
export const RECENT_DOCUMENTS_SEARCH_ACCEPT_VERSION = '1.1.0';

@Injectable()
export class SearchDataService {
  private _globalSearchHeaders: any = {
    [ACCEPT_VERSION_HEADER]: GLOBAL_SEARCH_ACCEPT_VERSION,
  };
  private _documentsSearchHeaders: any = {
    [ACCEPT_VERSION_HEADER]: DOCUMENTS_SEARCH_ACCEPT_VERSION,
  };
  private _recentDocumentsSearchHeaders: any = {
    [ACCEPT_VERSION_HEADER]: RECENT_DOCUMENTS_SEARCH_ACCEPT_VERSION,
  };

  constructor(private _authHttpService: AuthHttpService) {}

  searchGlobally(searchParams: ISearchParams): Observable<GlobalSearch> {
    return this._authHttpService
      .get(GLOBAL_SEARCH_URL, searchParams, this._globalSearchHeaders)
      .pipe(map(({ body, ..._ }: IResponseInfo) => new GlobalSearch(body)));
  }

  searchDocuments(searchParams: ISearchParams): Observable<DocumentsSearch> {
    return this._authHttpService
      .get(DOCUMENTS_SEARCH_URL, searchParams, this._documentsSearchHeaders)
      .pipe(map(({ body, ..._ }: IResponseInfo) => new DocumentsSearch(body)));
  }

  searchRecentDocuments(
    searchParams: ISearchParams
  ): Observable<RecentDocumentsSearch> {
    return this._authHttpService
      .get(
        RECENT_DOCUMENTS_SEARCH_URL,
        searchParams,
        this._recentDocumentsSearchHeaders
      )
      .pipe(
        map(({ body, ..._ }: IResponseInfo) => new RecentDocumentsSearch(body))
      );
  }
}
